import { createAction, props } from '@ngrx/store';
import { RouteModels } from '@share-models';

export const RouteActions = {
  setBreadcrumbs: createAction(
    '[Route] Set Breadcrumbs',
    props<{ breadcrumbs: RouteModels.UiBreadCrumbItem[] }>(),
  ),
};
